// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.report-request-modal .left {
  float: left;
  width: 6%;
  height: 100%;
}
.report-request-modal .right {
  float: right;
  width: 92%;
}
.report-request-modal .success-message {
  color: green;
  display: inline-block;
}
.report-request-modal .box-outer {
  overflow: auto;
  font-size: 16px;
  padding: 0 30px 30px 30px;
}
@media only screen and (min-height: 451px) and (max-height: 580px) {
  .report-request-modal .box-outer {
    max-height: 40vh;
  }
}
@media only screen and (max-height: 450px) {
  .report-request-modal .box-outer {
    max-height: 30vh;
  }
}
@media (max-width: 767px) {
  .report-request-modal .box-outer {
    overflow: hidden;
    max-height: 100%;
  }
}
.report-request-modal .model-box {
  top: 10%;
}
.report-request-modal .alertReport div {
  padding: 5px 20px !important;
}
.report-request-modal .alertReport {
  margin: -20px 30px -20px !important;
}
.report-request-modal .modal-footer {
  background: hsl(0, 0%, 95%);
  border-top: 1px solid #d2d2d2;
  bottom: 0;
  padding: 0px 30px;
  position: sticky;
  width: 100%;
}
@media only screen and (max-height: 438px) {
  .report-request-modal .modal-footer {
    position: relative;
  }
}
.report-request-modal .modal-header {
  padding: 30px 25px !important;
  position: relative;
}
.report-request-modal .modal-header h2 {
  font-size: 30px;
  font-weight: normal;
  margin: 0 !important;
  padding: 0;
  outline: none;
}
.report-request-modal .radio {
  margin-top: 20px;
  display: block !important;
}
.report-request-modal .sub-header {
  margin-top: 30px !important;
}
.report-request-modal .description {
  margin-bottom: -18px;
}
.report-request-modal label {
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 1.6rem;
}
.report-request-modal .button-group {
  padding: 20px 0;
}
.report-request-modal .button-group .btn-secondary {
  font-size: 17px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/report/report-request.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA/IE;EACE,WAAA;EACA,SAAA;EACA,YAAA;AAiJJ;AA/IE;EACE,YAAA;EACA,UAAA;AAiJJ;AA9IE;EACE,YAAA;EACA,qBAAA;AAgJJ;AA9IG;EACC,cAAA;EACA,eAAA;EAWC,yBAAA;AAsIL;AAhJI;EAHD;IAIG,gBAAA;EAmJJ;AACF;AAlJI;EAND;IAOG,gBAAA;EAqJJ;AACF;AApJI;EATD;IAUG,gBAAA;IACA,gBAAA;EAuJJ;AACF;AApJE;EACE,QAAA;AAsJJ;AApJE;EACE,4BAAA;AAsJJ;AAnJE;EACE,mCAAA;AAqJJ;AAjJE;EACE,2BAAA;EACA,6BAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAmJJ;AAlJI;EAPF;IAQI,kBAAA;EAqJJ;AACF;AAnJE;EACE,6BAAA;EACA,kBAAA;AAqJJ;AAnJI;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;AAqJN;AAlJE;EACE,gBAAA;EACA,yBAAA;AAoJJ;AAjJE;EACE,2BAAA;AAmJJ;AAjJE;EACE,oBAAA;AAmJJ;AAhJE;EACE,mCAAA;EACA,iBAAA;AAkJJ;AAhJE;EACE,eAAA;AAkJJ;AAhJI;EACE,eAAA;EACA,WAAA;AAkJN","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n//model popup\n.report-request-modal {\n  .left {\n    float: left;\n    width: 6%;\n    height: 100%;\n  }\n  .right{\n    float: right;\n    width: 92%;\n  }\n\n  .success-message {\n    color:  green;\n    display: inline-block\n  }\n   .box-outer {\n    overflow: auto;\n    font-size: 16px;\n    @media only screen and (min-height: 451px) and (max-height: 580px) {\n      max-height: 40vh;\n    }\n    @media only screen and (max-height: 450px) {\n      max-height: 30vh;\n    }\n    @media (max-width: 767px) {\n      overflow: hidden;\n      max-height: 100%;\n    }\n     padding: 0 30px 30px 30px;\n   }\n  .model-box{\n    top:10%;\n  }\n  .alertReport div {\n    padding: 5px 20px!important;\n  }\n\n  .alertReport{\n    margin: -20px 30px -20px!important; \n  }\n\n\n  .modal-footer {\n    background: color(default, base);\n    border-top: 1px solid color(default, dark);\n    bottom: 0;\n    padding: 0px 30px;\n    position: sticky;\n    width: 100%;\n    @media only screen and (max-height: 438px) {\n      position: relative;\n    }\n  }\n  .modal-header {\n    padding: 30px 25px !important;\n    position: relative;\n\n    h2 {\n      font-size: 30px;\n      font-weight: normal;\n      margin: 0 !important;\n      padding: 0;\n      outline: none;\n    }\n  }\n  .radio {\n    margin-top: 20px;\n    display: block !important;\n  }\n\n  .sub-header{\n    margin-top: 30px !important;\n  }\n  .description{\n    margin-bottom: -18px;\n  }\n\n  label{\n    font-family : 'Omnes-ATT-W02', Arial;\n    font-size: 1.6rem;\n  }\n  .button-group {\n    padding: 20px 0;\n\n    .btn-secondary {\n      font-size: 17px;\n      width: 100%;\n    }\n    }\n\n  // .error-message{\n  //       position: relative;\n  //       margin-left: 30px;\n  // .left {\n  //   background:rgb(183, 29, 29);;\n  //       position: absolute;\n  //     left: 0;\n  //     width: 34px;\n  //     height: 40px;\n  //     i{\n  //           margin-top: 3px;\n  //     }\n  //   }\n\n//   .right {\n// background: black;\n//     background: #313030;\n//     height: 40px;\n//     color: white;\n//     margin: 0px 20px;\n//       line-height: 35px;\n//         padding: 5px 10px;\n//     font-size: 14px;\n//   }\n// }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
